<template>
  <TabIncluded
    v-if="data"
    dataRootKey="consumer_section"
    :stages="['Highlights', 'Included']"
    :data="[data]"
    :pdf-data="pdfData"
    :isCompletedQuote="false"
    :hidePopovers="false"
    :isImporting="isImporting"
    :key="componentKey">
    <template v-slot:options>
      <div class="d-flex justify-content-end align-content-end text-center-mobile">
        <div class="container-fluid row">
          <div class="col col-md-8 col-12">
            <p>{{ message }}<span data-v-ea3d52d4=""><svg data-v-ea3d52d4="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="info-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-info-circle fa-w-16 fa-lg"><path data-v-ea3d52d4="" fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z" class=""></path></svg></span>.</p>
          </div>
          <div class="col col-md-4 col-12">
            <FlyerPreviewButton :on-loaded="(pdf) => pdfData = pdf" />
            <BaseButton
              type="button"
              style="float: right"
              classButton="btn btn-primary btn-sm"
              :disabled="isImporting || inclusionsAdded"
              @click="importInclusions">
              <span v-if="! isImporting">Import inclusions</span>
              <span v-if="isImporting"><font-awesome-icon :icon="['fas', 'spinner']" class="mr-1" spin /> Importing inclusions</span>
            </BaseButton>
          </div>
        </div>
      </div>
    </template>
  </TabIncluded>
</template>

<script>
import TabIncluded from '@/components/opportunity-edit/TabIncluded.vue'
import FlyerPreviewButton from "@/components/opportunity-edit/FlyerPreviewButton.vue";
import PDFViewer from "@/components/_shared/PDFViewer.vue";

export default {
  name: 'TabTripInclusions',
  components: {PDFViewer, FlyerPreviewButton, TabIncluded },
  props: {
    data: {
      type: Object,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    },
    isImporting: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      componentKey: 0,
      pdfData: '',
    }
  },
  computed: {
    inclusionsAdded() {
      return (this.data.highlights && this.data.highlights.length > 0) ||
            (this.data.whatsincluded && this.data.whatsincluded.length > 0)
    },
    message() {
      return this.inclusionsAdded ? 'You can´t import inclusions because you already have some' : 'Import here. Please note space is unlimited on the Landing Page, however restricted on the Sales Flyer. Navigate the limits here'
    }
  },
  methods: {
    importInclusions () {
      this.$emit('import')
      this.forceRerender()
    },
    forceRerender () {
      this.componentKey += 1
    }
  }
}
</script>

<style lang="scss" scopep>
</style>
